interface IOrderable {
  order: number;
}

export const sortByOrder = <T extends IOrderable>(array: T[]): T[] =>
  array.sort((a, b) => a.order - b.order);
